import * as Matter from 'matter-js';
import rand from 'random-seed';
import polyDecomp from 'poly-decomp';

/*
 * Constants
 ***************************/
 const $ = jQuery.noConflict();
 const mobileBreakpoint = parseInt(gauravVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(gauravVars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
    let isMobileNavigationActive = ( windowWidth <= navBreakpoint );

  /* Physics Config */
  let seed = 'Gaurav Kapadia************';

  /* AJAX post loading */
  let ajaxIsLoading = false,
    ajaxRequest = null,
    ghostMarkup = null,
    ignoreThisOneClick = false;

  const cachedPosts = {};

/*
* Viewport height adjustments
***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/**
 * PhysicsConfig - Configuration object for physics properties
 */
const PhysicsConfig = {
  gravity: isMobile ? 1.8 : 2.4,
  bodiesAreVisible: 0,
  staggerInterval: 120,
  introOffset: 0,
  usingHoverMedia: false,
  physicsOptions: {
    friction: 0.1,
    frictionStatic: isMobile ? 0.5 : 0.8,
    frictionAir: isMobile ? 0.01 : 0.0005,
    restitution: 0,
    slop: 0.4
  }
};

console.log(PhysicsConfig);

/**
 * PhysicsEngine - Manages Matter.js physics engine and rendering
 */
class PhysicsEngine {
  constructor(canvasElement, width, height) {
    this.Matter = Matter;
    this.Common = Matter.Common;
    this.Common.setDecomp(polyDecomp);
    
    this.engine = Matter.Engine.create();
    this.world = this.engine.world;
    this.world.gravity.y = PhysicsConfig.gravity;
    this.world.bodies = [];
    
    this.render = Matter.Render.create({
      element: canvasElement,
      engine: this.engine,
      options: {
        wireframes: false,
        showAngleIndicator: false,
        background: 'transparent',
        height: height,
        width: width
      }
    });
    
    Matter.Render.run(this.render);
    this.runner = Matter.Runner.create();
    Matter.Runner.run(this.runner, this.engine);
    
    this.mouseConstraint = null;
    this.boundaries = {};
    this.maxX = width; // Store max X for reference
  }
  
  setupMouseControl() {
    if (document.body.classList.contains('disable-mouse-effects')) {
      return null;
    }
    
    const mouse = Matter.Mouse.create(this.render.canvas);
    this.mouseConstraint = Matter.MouseConstraint.create(this.engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false },
        collisionFilter: { category: 0x0001 }
      }
    });
    
    Matter.Composite.add(this.world, this.mouseConstraint);
    this.render.mouse = mouse;
    
    // Allow page scrolling while on the canvas
    mouse.element.removeEventListener("wheel", mouse.mousewheel);
    mouse.element.removeEventListener("mousewheel", mouse.mousewheel);
    mouse.element.removeEventListener("DOMMouseScroll", mouse.mousewheel);
    
    // Enable pointer events on the actual canvas element
    this.render.canvas.style.pointerEvents = 'auto';
    
    return this.mouseConstraint;
  }
  
  createBoundaries(maxX, height) {
    const ground = Matter.Bodies.rectangle(
      (maxX / 2) + 160, window.innerHeight, maxX + 320, 90 * 2,
      { render: { fillStyle: '#0000F8', opacity: PhysicsConfig.bodiesAreVisible }, isStatic: true }
    );
    
    const wallLeft = Matter.Bodies.rectangle(
      -80, window.innerHeight / 2, 160 + 48, window.innerHeight,
      { isStatic: true, render: { fillStyle: '#0000F8', opacity: PhysicsConfig.bodiesAreVisible } }
    );
    
    const wallRight = Matter.Bodies.rectangle(
      maxX + 80, window.innerHeight / 2, 160, 1200,
      { isStatic: true, render: { fillStyle: '#0000F8', opacity: PhysicsConfig.bodiesAreVisible } }
    );
    
    const roof = Matter.Bodies.rectangle(
      (maxX / 2) + 160, -80, maxX + 320, 160, { isStatic: true }
    );
    
    if (window.innerWidth < 768) {
      Matter.Body.scale(ground, 1, 70 / 90);
    }
    
    Matter.World.add(this.world, [ground, wallLeft, wallRight, roof]);
    
    this.boundaries = { ground, wallLeft, wallRight, roof, groundIsMobile: window.innerWidth < 768 };
    return this.boundaries;
  }
  
  updateBoundaries(maxX, height) {
    const { ground, groundIsMobile } = this.boundaries;
    
    // Update maxX for reference
    this.maxX = maxX;
    
    Matter.Body.set(ground, {
      position: { x: (maxX / 2) + 160, y: window.innerHeight }
    });
    
    if (window.innerWidth < 768 && !groundIsMobile) {
      Matter.Body.scale(ground, 1, 70 / 90);
      this.boundaries.groundIsMobile = true;
    } else if (window.innerWidth >= 768 && groundIsMobile) {
      Matter.Body.scale(ground, 1, 90 / 70);
      this.boundaries.groundIsMobile = false;
    }
  }
  
  updateCanvasSize(width, height) {
    this.render.canvas.height = height;
    this.render.bounds.max.y = height;
    this.render.options.height = height;
  }
  
  addBody(body) {
    Matter.World.add(this.world, [body]);
  }
  
  onAfterUpdate(callback) {
    Matter.Events.on(this.engine, 'afterUpdate', callback);
  }
  
  applyForceToBody(body, force) {
    Matter.Body.applyForce(body, body.position, force);
  }
}

/**
 * ShelfObject - Base class for shelf objects (books and custom objects)
 */
class ShelfObject {
  constructor(element, index, physicsEngine) {
    this.element = element;
    this.index = index;
    this.physicsEngine = physicsEngine;
    this.body = null;
    this.width = 0;
    this.height = 0;
    this.offset = { x: 0, y: 0 };
  }
  
  getClientRect() {
    return this.element.getClientRects()[0];
  }
  
  setPosition(x, y) {
    this.element.style.position = 'absolute';
    gsap.set(this.element, { left: x, top: y, opacity: 0 });
  }
  
  addToWorld(delay) {
    setTimeout(() => {
      this.physicsEngine.addBody(this.body);
      gsap.to(this.element, { opacity: 1, scale: 1 });
    }, delay);
  }
  
  updatePosition() {
    const { x, y } = this.body.position;
    const angle = this.body.angle;
    
    // Get the current scroll/drag offset from the scroll manager
    const offset = window.scrollManager ? window.scrollManager.getTotalOffset() : 0;
    
    if (this.offset.x === 0 && this.offset.y === 0) {
      this.element.style.top = `${y - (this.element.offsetHeight / 2)}px`;
      this.element.style.left = `${x - (this.element.offsetWidth / 2) + offset}px`;
      gsap.set(this.element, { rotate: `${angle}rad` });
    } else {
      const { width, height } = this;
      this.element.style.top = (height * this.offset.y * -1) - (height / 2) + 'px';
      this.element.style.left = (width * this.offset.x * -1) - (width / 2) + 'px';
      gsap.set(this.element, {
        x: x + offset,
        y: y,
        rotate: `${angle}rad`,
        transformOrigin: `${(this.offset.x * 100) + 50}% ${(this.offset.y * 100) + 50}%`
      });
    }
  }
  
  scaleBody(newWidth, newHeight) {
    const bodyAngle = this.body.angle;
    Matter.Body.setAngle(this.body, 0);
    Matter.Body.scale(this.body, newWidth / this.width, newHeight / this.height);
    Matter.Body.setAngle(this.body, bodyAngle);
    this.width = newWidth;
    this.height = newHeight;
  }
}

/**
 * BookObject - Represents a book on the shelf
 */
class BookObject extends ShelfObject {
  constructor(element, index, physicsEngine) {
    super(element, index, physicsEngine);
    this.media = element.querySelector('[data-book-media]');
    this.title = element.querySelector('.book-title');
  }
  
  createBody(x, y, rotation) {
    const args = {
      ...PhysicsConfig.physicsOptions,
      label: this.title.textContent,
      mass: 70,
      angle: rotation * (Math.PI / 180),
      collisionFilter: { category: 0x0002 },
      render: { fillStyle: '#000000', opacity: PhysicsConfig.bodiesAreVisible }
    };
    
    this.body = Matter.Bodies.rectangle(x, y, this.element.clientWidth, this.element.clientHeight, args);
    this.width = this.element.clientWidth;
    this.height = this.element.clientHeight;
    
    return this.body;
  }
  
  setupMedia(backgroundContainer) {
    if (PhysicsConfig.usingHoverMedia && this.media) {
      backgroundContainer.appendChild(this.media);
      this.media.setAttribute('class', 'tw-opacity-0 tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-object-cover tw-blur-lg');
    }
  }
  
  showMedia() {
    if (this.media && PhysicsConfig.usingHoverMedia) {
      gsap.to(this.media, { opacity: 0.3, scale: 1.2 });
    }
  }
  
  hideMedia() {
    if (this.media && PhysicsConfig.usingHoverMedia) {
      gsap.to(this.media, { opacity: 0, scale: 1 });
    }
  }
}

/**
 * CustomObject - Represents custom objects (shoe, speaker, etc.)
 */
class CustomObject extends ShelfObject {
  constructor(element, index, physicsEngine) {
    super(element, index, physicsEngine);
    this.objectSlug = element.getAttribute('data-object');
    this.isStatic = element.getAttribute('data-static') === 'true';
    this.gsapAnim = null;
    this.lottieAnim = null;
    this.doneFirstClick = false;
    
    if (element.getAttribute('data-offset')) {
      this.offset = JSON.parse(element.getAttribute('data-offset'));
    }
  }
  
  createBody(x, y) {
    const path = this.element.querySelector('.object-path');
    const vertices = Matter.Svg.pathToVertices(path);
    
    const args = {
      ...PhysicsConfig.physicsOptions,
      render: { fillStyle: '#FF0000', opacity: PhysicsConfig.bodiesAreVisible },
      collisionFilter: { category: this.isStatic ? 0x0001 : 0x0002 },
      mass: 50,
      isStatic: this.isStatic
    };
    
    this.body = Matter.Bodies.fromVertices(x, y, [vertices], args);
    
    const dimensions = $(this.element).data('dimensions');
    Matter.Body.scale(
      this.body,
      this.element.clientWidth / dimensions.width,
      this.element.clientHeight / dimensions.height
    );
    
    this.width = this.element.clientWidth;
    this.height = this.element.clientHeight;
    
    this.setupInnerOffset();
    this.setupAnimations();
    
    return this.body;
  }
  
  setupInnerOffset() {
    const inner = this.element.querySelector('.shelf-object-custom__inner');
    if (inner !== null) {
      inner.style.left = (this.offset.x * this.width * 2) + 'px';
      inner.style.top = (this.offset.y * this.height * 2) + 'px';
    }
  }
  
  setupAnimations() {
    if (this.objectSlug === 'shoe') {
      this.setupShoeAnimation();
    } else if (this.objectSlug === 'speaker') {
      this.setupSpeakerAnimation();
    }
    
    if (this.element.hasAttribute('data-lottie')) {
      this.setupLottieAnimation();
    }
  }
  
  setupShoeAnimation() {
    const imgArr = shuffle(gauravVars.sneakers);
    let shoeIndex = 0;
    const arrLen = imgArr.length;
    new Image().src = imgArr[0];
    
    this.gsapAnim = gsap.timeline({ paused: true });
    
    this.gsapAnim.to(this.element.querySelector('img'), {
      scale: 0.95,
      duration: 0.3,
      ease: 'power3.in',
      onComplete: () => {
        this.element.querySelector('img').src = imgArr[shoeIndex % arrLen];
        shoeIndex++;
        if (shoeIndex < arrLen) {
          new Image().src = imgArr[shoeIndex];
        }
      }
    });
    
    this.gsapAnim.to(this.element.querySelector('img'), {
      scale: 1,
      duration: 0.3,
      ease: 'elastic.out(1, 0.3)'
    });
  }
  
  setupSpeakerAnimation() {
    this.gsapAnim = gsap.timeline({
      repeat: -1,
      yoyo: true,
      paused: true,
      data: {
        playing: false,
        onPause: (anim) => {
          ignoreThisOneClick = true;
          $('[data-playlist-toggle]').trigger('click');
          anim.data.playing = false;
        },
        onStart: (anim) => {
          if ($('[data-playlist-toggle]').length) {
            const modalIsActive = $('[data-playlist-modal]').hasClass('active');
            
            if (anim.data.playing === false && modalIsActive === false) {
              anim.data.playing = true;
              ignoreThisOneClick = true;
              $('[data-playlist-toggle]').trigger('click');
            } else if (anim.data.playing === false && modalIsActive === true) {
              anim.pause();
              anim.data.onPause(anim);
            }
          }
        }
      },
      onInterrupt: function() {
        this.data.playing = false;
      }
    });
    
    this.gsapAnim
      .to('.speaker-upper', { scale: 1.05, transformOrigin: 'center center', duration: 0.33, ease: 'elastic.out(1.5, 0.7)' })
      .to('.speaker-upper', { scale: 1, transformOrigin: 'center center', duration: 0.33, ease: 'elastic.out(1.5, 0.7)' })
      .to('.speaker-upper', { scale: 1.05, transformOrigin: 'center center', duration: 0.33, ease: 'elastic.out(1.5, 0.7)' })
      .to('.nozzle', { rotate: '15deg', transformOrigin: 'center center', duration: 0.33, ease: 'power3.inOut' }, '0')
      .to('.nozzle', { rotate: '-55deg', transformOrigin: 'center center', duration: 0.66, ease: 'power3.inOut' }, '0.33');
  }
  
  setupLottieAnimation() {
    const animContainer = document.createElement('div');
    animContainer.classList.add('shelf-object-custom--lottie', 'tw-absolute', 'tw-bottom-0', 'tw-left-0', 'tw-w-full', 'tw-h-full');
    this.element.querySelector('.shelf-object-custom__inner').appendChild(animContainer);
    
    const anim = bodymovin.loadAnimation({
      renderer: 'svg',
      container: animContainer,
      autoplay: false,
      path: this.element.getAttribute('data-lottie'),
      loop: false,
      initialSegment: this.element.hasAttribute('data-lottie-intro') 
        ? JSON.parse(this.element.getAttribute('data-lottie-intro')) 
        : [0, 1]
    });
    
    anim.addEventListener('DOMLoaded', () => {
      this.element.querySelector('[data-object-texture]').style.display = 'none';
    });
    
    this.lottieAnim = {
      lottie: anim,
      intro: this.element.hasAttribute('data-lottie-intro') 
        ? JSON.parse(this.element.getAttribute('data-lottie-intro')) 
        : [0, 1],
      outro: this.element.hasAttribute('data-lottie-outro') 
        ? JSON.parse(this.element.getAttribute('data-lottie-outro')) 
        : null,
      playState: 'forwards'
    };
  }
  
  handleClick() {
    const linkInEl = this.element.querySelector('a');
    
    if (this.lottieAnim) {
      return this.handleLottieClick(linkInEl);
    }
    
    if (this.gsapAnim) {
      return this.handleGsapClick(linkInEl);
    }
    
    if (linkInEl) {
      linkInEl.click();
    }
  }
  
  handleLottieClick(linkInEl) {
    const { lottie, intro, outro, playState } = this.lottieAnim;
    
    if (playState === 'forwards') {
      lottie.setDirection(1);
      lottie.playSegments(intro, true);
      this.lottieAnim.playState = 'backwards';
    } else {
      if (outro === null) {
        lottie.setSpeed(-1);
        lottie.setDirection(-1);
        lottie.goToAndPlay(intro[1], true);
      } else {
        lottie.playSegments(outro, true);
      }
      this.lottieAnim.playState = 'forwards';
    }
    
    if (linkInEl) {
      linkInEl.click();
    }
    this.doneFirstClick = true;
  }
  
  handleGsapClick(linkInEl) {
    if (!this.gsapAnim.isActive()) {
      this.gsapAnim.seek(0);
      this.gsapAnim.play();
      this.gsapAnim.data.onStart(this.gsapAnim);
      
      if (linkInEl) {
        linkInEl.click();
      }
      this.doneFirstClick = true;
    } else if (this.gsapAnim.vars.repeat === -1) {
      this.gsapAnim.pause();
      this.gsapAnim.data.onPause(this.gsapAnim);
    }
  }
  
  updateStaticPosition() {
    if (this.body.isStatic) {
      gsap.to(this.element, {
        top: window.innerHeight - this.getClientRect().height - $('[data-playlist-area]').outerHeight(),
        ease: 'bounce.out',
        duration: 0.7,
        onUpdate: () => {
          Matter.Body.setPosition(this.body, {
            x: this.body.position.x,
            y: this.getClientRect().y + (this.getClientRect().height / 2)
          });
        }
      });
    }
  }
}

/**
 * ShelfManager - Manages all shelf objects and their interactions
 */
class ShelfManager {
  constructor(physicsEngine, booksContainer, backgroundContainer) {
    this.physicsEngine = physicsEngine;
    this.booksContainer = booksContainer;
    this.backgroundContainer = backgroundContainer;
    this.shelfObjects = {};
    this.dragBody = null;
    this.anyMovementsDone = false;
  }
  
  addObject(shelfObject) {
    this.shelfObjects[shelfObject.body.id] = shelfObject;
  }
  
  getObject(bodyId) {
    return this.shelfObjects[bodyId];
  }
  
  getAllBodies() {
    return Object.values(this.shelfObjects).map(obj => obj.body);
  }
  
  updateAllPositions() {
    for (const bodyId in this.shelfObjects) {
      this.shelfObjects[bodyId].updatePosition();
    }
  }
  
  refreshAllObjects() {
    this.physicsEngine.runner.enabled = false;
    
    for (const bodyId in this.shelfObjects) {
      const obj = this.shelfObjects[bodyId];
      obj.scaleBody(obj.element.clientWidth, obj.element.clientHeight);
      
      if (obj instanceof CustomObject) {
        obj.updateStaticPosition();
      }
    }
    
    this.physicsEngine.runner.enabled = true;
  }
  
  resetAllObjects(layoutManager) {
    this.physicsEngine.runner.enabled = false;
    
    
    // Get sorted objects to reset them in order
    const sortedObjects = Object.values(this.shelfObjects).sort((a, b) => a.index - b.index);
    
    // First pass: Clear all transforms and get natural DOM positions
    sortedObjects.forEach((obj) => {
      // Clear all GSAP transforms to get back to natural DOM position
      gsap.set(obj.element, { clearProps: 'all' });
    });
    
    // Force a reflow to ensure positions are calculated correctly
    void sortedObjects[0].element.offsetHeight;
    
    // Reset layout manager state with natural starting position
    layoutManager.lastXMin = layoutManager.objects[0].getBoundingClientRect().x;
    layoutManager.stackFlag = false;
    
    // Second pass: Re-position DOM elements and update physics bodies
    sortedObjects.forEach((obj, index) => {
      const el = obj.element;
      
      // Reset element styling for animation
      gsap.set(el, { opacity: 0 });
      
      layoutManager.updateStackFlag(index);
      
      let box, rotation, newX, newY;
      
      if (obj instanceof BookObject) {
        box = layoutManager.positionBook(el, index);
        rotation = gsap.getProperty(el, 'rotation');
        newX = box.x + box.width / 2;
        newY = box.y + box.height / 2;
        
        // Update the existing body's position and rotation
        Matter.Body.setPosition(obj.body, { x: newX, y: newY });
        Matter.Body.setAngle(obj.body, rotation * (Math.PI / 180));
        Matter.Body.setVelocity(obj.body, { x: 0, y: 0 });
        Matter.Body.setAngularVelocity(obj.body, 0);
        
      } else if (obj instanceof CustomObject) {
        const objectSlug = el.getAttribute('data-object');
        box = layoutManager.positionCustomObject(el, index, objectSlug);
        newX = box.x + box.width / 2;
        newY = box.y + box.height / 2;
        
        // Update the existing body's position and reset rotation
        Matter.Body.setPosition(obj.body, { x: newX, y: newY });
        Matter.Body.setAngle(obj.body, 0);
        Matter.Body.setVelocity(obj.body, { x: 0, y: 0 });
        Matter.Body.setAngularVelocity(obj.body, 0);
      }
      
      // Animate element back in with delay
      const delay = layoutManager.calculateIntroDelay(index);
      setTimeout(() => {
        gsap.to(el, { opacity: 1 });
        if ( index === 4 && $('[data-scroll-indicator]').length ) {
          gsap.to('[data-scroll-indicator]', {
            opacity: 1,
            duration: 0.6,
          });
        }
      }, delay);
    });
    
    // Recalculate bounds and update boundaries
    setTimeout(() => {
      const maxBookX = Math.max(...Object.values(this.shelfObjects).map(obj => {
        const clientRects = obj.element.getClientRects();
        return clientRects.length > 0 ? clientRects[0].x + clientRects[0].width : 0;
      }));
      const maxX = Math.max(maxBookX, window.innerWidth);
      
      this.booksContainer.style.width = `${maxX}px`;
      this.physicsEngine.render.bounds.max.x = maxX;
      this.physicsEngine.render.options.width = maxX;
      this.physicsEngine.render.canvas.width = maxX;
      
      // Update boundary positions (they're static so we can update them)
      this.physicsEngine.updateBoundaries(maxX, window.innerHeight);
      
      // Scroll back to start
      window.scrollTo(0, 0);
      
      this.physicsEngine.runner.enabled = true;
      this.anyMovementsDone = false;
      
      // Hide the refresh button
      gsap.to('[data-refresh-button]', {
        opacity: 0,
        scale: 0.7,
        duration: 0.3,
        ease: 'power3.inOut',
        onComplete: () => {
          gsap.set('[data-refresh-button]', {
            'visibility': 'hidden',
            'pointer-events': 'none'
          });
        }
      });
    }, 100);
  }
  
  handleDragStart(body) {
    if (this.dragBody !== null) {
      const prevObj = this.getObject(this.dragBody.id);
      if (prevObj instanceof BookObject) {
        prevObj.hideMedia();
      }
    }
    
    this.dragBody = body;
    const currentObj = this.getObject(body.id);
    if (currentObj instanceof BookObject) {
      currentObj.showMedia();
    }
  }
  
  handleDragEnd() {
    if (!this.anyMovementsDone) {
      gsap.set('[data-refresh-button]', {
        'visibility': 'visible',
        'pointer-events': 'auto',
        scale: 0.7
      });
      gsap.to('[data-refresh-button]', {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: 'power3.inOut'
      });
      this.anyMovementsDone = true;
    }
  }
  
  handleClick(x, y, offset) {
    const bodiesUnder = Matter.Query.point(this.getAllBodies(), { x: x - offset, y: y });
    
    if (bodiesUnder.length > 0) {
      const bodyToClick = bodiesUnder[0];
      const obj = this.getObject(bodyToClick.id);
      
      if (obj instanceof CustomObject) {
        obj.handleClick();
      } else if (obj instanceof BookObject) {
        const linkInEl = obj.element.querySelector('a');
        if (linkInEl) {
          linkInEl.click();
        }
      }
    }
  }
  
  handleMouseMove(x, y, offset) {
    const bodiesUnder = Matter.Query.point(this.getAllBodies(), { x: x - offset, y: y });
    
    if (bodiesUnder.length > 0) {
      const bodyToHover = bodiesUnder[0];
      const obj = this.getObject(bodyToHover.id);
      const linkInEl = obj.element.querySelector('a');
      if (linkInEl) {
        $(linkInEl).trigger('mouseenter');
      }
    }
  }
}

// start bookshelf stuff
const canvas = document.createElement('div');
document.querySelector('body').appendChild(canvas);
canvas.setAttribute('id', 'canvas');
canvas.style.position = 'fixed';
canvas.style.top = '0';
canvas.style.left = '0';
canvas.style.zIndex = '10';
canvas.style.pointerEvents = 'none'; // Start with pointer events disabled on the container

const booksContainer = document.querySelector('[data-shelf-container]');
const backgroundContainer = document.querySelector('[data-background-area]');
let width = booksContainer.clientWidth,
  height = booksContainer.clientHeight;

const fontsLoadedActions = [];

document.fonts.onloadingdone = () => {
  if (fontsLoadedActions.length > 0) {
    for (var i = 0; i < fontsLoadedActions.length; i++) {
      fontsLoadedActions[i]();
    }
  }
};

// Initialize physics engine
const physicsEngine = new PhysicsEngine(canvas, width, height);
const mouseConstraint = physicsEngine.setupMouseControl();
const shelfManager = new ShelfManager(physicsEngine, booksContainer, backgroundContainer);

// Make globally accessible
window.physicsEngine = physicsEngine;
window.shelfManager = shelfManager;

/**
 * ObjectLayoutManager - Handles positioning and layout of objects
 */
class ObjectLayoutManager {
  constructor(objects, seed) {
    this.objects = objects;
    this.seed = seed;
    this.lastXMin = objects[0].getBoundingClientRect().x;
    this.stackFlag = false;
    this.stackStart = 2;
    this.stackEnd = 4;
  }
  
  calculateIntroDelay(index) {
    if (this.stackFlag) {
      return PhysicsConfig.introOffset + this.stackFlag * PhysicsConfig.staggerInterval + (index * 3);
    } else if (index > this.stackEnd) {
      return PhysicsConfig.introOffset + (index - this.stackEnd) * PhysicsConfig.staggerInterval;
    } else {
      return PhysicsConfig.introOffset + index * PhysicsConfig.staggerInterval;
    }
  }
  
  positionBook(element, index) {
    element.style.position = 'absolute';
    
    const leftPos = this.stackFlag && index > this.stackStart 
      ? this.lastXMin - this.objects[index - 1].getClientRects()[0].width 
      : this.lastXMin;
    
    const topPos = this.stackFlag 
      ? (index > this.stackStart ? this.objects[index - 1].getClientRects()[0].y : 0)
      : '-=' + rand(this.seed + index)(156);
    
    gsap.set(element, { left: leftPos, top: topPos, opacity: 0 });
    
    if (this.stackFlag) {
      this.positionStackedBook(element, index);
    } else if (index > 0) {
      this.applyBookTilt(element, index);
    }
    
    const box = element.getClientRects()[0];
    
    if (this.stackFlag) {
      this.lastXMin = Math.max(this.lastXMin, Math.ceil(box.x + box.width));
    } else {
      this.lastXMin = Math.ceil(box.x + box.width) + 1;
    }
    
    return box;
  }
  
  positionStackedBook(element, index) {
    gsap.set(element, { rotate: '-90deg' });
    
    if (index === this.stackStart) {
      const adjBox = element.getClientRects()[0];
      gsap.set(element, {
        left: this.lastXMin + Math.ceil(Math.abs(this.lastXMin - adjBox.x)),
        top: booksContainer.clientHeight - (element.getClientRects()[0].width / 2) - 
             (element.getClientRects()[0].height / 2) - rand(this.seed + this.stackStart)(156)
      });
    } else {
      const adjBox = element.getClientRects()[0];
      const prevBox = this.objects[index - 1].getClientRects()[0];
      gsap.set(element, {
        left: Math.ceil(prevBox.x + (prevBox.x - adjBox.x) + 
              rand(this.seed + index)(prevBox.width - adjBox.width)),
        top: prevBox.y - (element.getClientRects()[0].width / 2) - 
             (element.getClientRects()[0].height / 2) - rand(this.seed + this.stackStart)(156)
      });
    }
  }
  
  applyBookTilt(element, index) {
    const isTilted = index < 11 
      ? [false, true, false, false, false, true, false, true, false, false, false][index]
      : (rand(this.seed + index)(100) <= 25);
    
    if (isTilted) {
      const hardcodedRotations = { 1: -6, 5: 8, 7: 8 };
      const rotation = hardcodedRotations.hasOwnProperty(index) 
        ? hardcodedRotations[index]
        : rand(this.seed + index)(-50, 50) * 2 * (index % 6 === 0 ? -1 : 1);
      
      gsap.set(element, { rotation: rotation });
      
      const adjBox = element.getClientRects()[0];
      gsap.set(element, { left: this.lastXMin + Math.abs(this.lastXMin - adjBox.x) });
    }
  }
  
  positionCustomObject(element, index, objectSlug) {
    element.style.position = 'absolute';
    
    if (this.stackFlag) {
      const prevBox = this.objects[index - 1].getClientRects()[0];
      gsap.set(element, {
        top: prevBox.y - (element.getClientRects()[0].width / 2) - 
             (element.getClientRects()[0].height / 2) - rand(this.seed + this.stackStart)(156)
      });
    } else if (objectSlug === 'shoe') {
      const prevBox = this.objects[index - 1].getClientRects()[0];
      gsap.set(element, {
        top: Math.max(prevBox.y - (element.getClientRects()[0].width / 2) - 
                     (element.getClientRects()[0].height / 2) - rand(this.seed + this.stackStart)(24), 0)
      });
    }
    
    if (element.getAttribute('data-offset')) {
      const offset = JSON.parse(element.getAttribute('data-offset'));
      this.lastXMin += (offset.x * element.getClientRects()[0].width) * -1;
      if (!this.stackFlag) {
        gsap.set(element, {
          top: element.getClientRects()[0].y - (offset.y * element.getClientRects()[0].height)
        });
      }
    }
    
    let leftPos = this.stackFlag && index > this.stackStart 
      ? this.lastXMin - this.objects[index - 1].getClientRects()[0].width 
      : this.lastXMin;
    
    if (objectSlug === 'shoe') {
      leftPos = this.lastXMin - this.objects[index - 2].getClientRects()[0].width;
    }
    
    gsap.set(element, { left: leftPos, opacity: 0 });
    
    const box = element.getClientRects()[0];
    
    if (this.stackFlag) {
      this.lastXMin = Math.max(this.lastXMin, Math.ceil(box.x + box.width));
    } else {
      this.lastXMin = Math.ceil(box.x + box.width) + 1;
    }
    
    if (element.getAttribute('data-offset') && index !== this.objects.length - 1) {
      const offset = JSON.parse(element.getAttribute('data-offset'));
      this.lastXMin -= Math.floor(offset.x * element.getClientRects()[0].width) * -1;
    }
    
    return box;
  }
  
  updateStackFlag(index) {
    if (index === this.stackStart) {
      this.stackFlag = true;
    }
    if (index === this.stackEnd + 1) {
      this.stackFlag = false;
    }
  }
}

const objects = booksContainer.querySelectorAll('[data-shelf-object-type]');
const layoutManager = new ObjectLayoutManager(objects, seed);
window.layoutManager = layoutManager; // Make it globally accessible
let lastXMin = objects[0].getBoundingClientRect().x;

// Create all shelf objects
objects.forEach(function(el, index) {
  layoutManager.updateStackFlag(index);
  
  if (el.getAttribute('data-shelf-object-type') === 'book') {
    const box = layoutManager.positionBook(el, index);
    
    const bookObj = new BookObject(el, index, physicsEngine);
    bookObj.setupMedia(backgroundContainer);
    
    const rotation = gsap.getProperty(el, 'rotation');
    bookObj.createBody(box.x + box.width / 2, box.y + box.height / 2, rotation);
    shelfManager.addObject(bookObj);
    
    const delay = layoutManager.calculateIntroDelay(index);
    bookObj.addToWorld(delay);
    
  } else if (el.getAttribute('data-shelf-object-type') === 'custom') {
    const objectSlug = el.getAttribute('data-object');
    const box = layoutManager.positionCustomObject(el, index, objectSlug);
    
    const customObj = new CustomObject(el, index, physicsEngine);
    customObj.createBody(box.x + box.width / 2, box.y + box.height / 2);
    shelfManager.addObject(customObj);
    
    const delay = layoutManager.calculateIntroDelay(index);
    customObj.addToWorld(delay);
    if ( index === 4 && $('[data-scroll-indicator]').length ) {
      setTimeout(() => {
        gsap.to('[data-scroll-indicator]', {
          opacity: 1,
          duration: 0.6,
        });
      }, delay + 400);
    }
  }
});

// Utility function for debouncing
function debounce(func) {
  var timer;
  return function(event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
}

// Handle font loading
fontsLoadedActions.push(function() {
  shelfManager.refreshAllObjects();
});

// Handle window resize
$(window).on('resize', debounce(function() {
  shelfManager.refreshAllObjects();
  physicsEngine.updateBoundaries(maxX, height);
}));

// Calculate canvas bounds
const maxBookX = Math.max(...Object.values(shelfManager.shelfObjects).map(obj => {
  const clientRects = obj.element.getClientRects();
  return clientRects.length > 0 ? clientRects[0].x + clientRects[0].width : 0;
}));
const maxX = Math.max(maxBookX, window.innerWidth);

booksContainer.style.width = `${maxX}px`;
physicsEngine.render.bounds.max.x = maxX;
physicsEngine.render.options.width = maxX;
physicsEngine.render.canvas.width = maxX;

// Create world boundaries
physicsEngine.createBoundaries(maxX, height);

// Handle canvas size updates
window.addEventListener('resize', debounce(function() {
  width = booksContainer.clientWidth;
  height = booksContainer.clientHeight;
  physicsEngine.updateCanvasSize(width, height);
}));

/**
 * ScrollManager - Manages scrolling and dragging interactions
 */
class ScrollManager {
  constructor(canvas, booksContainer, maxBookX, width) {
    this.canvas = canvas;
    this.booksContainer = booksContainer;
    this.maxBookX = maxBookX;
    this.width = width;
    this.needsScroll = true;
    this.documentScroller = null;
    this.scrollDiff = 0;
    this.currentOffset = 0;
    this.scrollSizer = document.querySelector('[data-scroll-sizer]');
    
    this.setupScrollTrigger();
    this.setupDragger();
  }
  
  setupScrollTrigger() {
    if (this.maxBookX >= this.width) {
      this.scrollDiff = Math.abs(this.maxBookX - this.width);
      this.scrollSizer.style.height = 'calc((var(--vh,1vh) * 100) + var(--scroll-distance))';
      document.documentElement.style.setProperty('--scroll-distance', `${this.scrollDiff}px`);

      this.scrollIndicator = ScrollTrigger.create({
        trigger: this.scrollSizer,
        start: 'top top-=24',
        end: 'bottom bottom',
        onEnter: () => {
          gsap.to('[data-scroll-indicator]', { opacity: 0, duration: 0.3 });
        },
        onLeaveBack: () => {
          gsap.to('[data-scroll-indicator]', { opacity: 1, duration: 0.3 });
        }
      });
      
      this.documentScroller = ScrollTrigger.create({
        trigger: this.scrollSizer,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const offset = self.progress * (this.maxBookX - this.width + 48) * -1;
          this.currentOffset = offset;
        },
      });
    } else {
      this.needsScroll = false;
    }
  }
  
  setupDragger() {
    if (!this.needsScroll) {
      return; // No dragging needed if content fits
    }
    
    // Use physics engine mouse events for scene dragging
    this.isDraggingScene = false;
    this.hasMovedDuringDrag = false;
    this.dragStartX = 0;
    this.dragStartScroll = 0;
    this.lastMouseX = 0;
    this.velocityTracker = [];
    
    const canvas = window.physicsEngine.render.canvas;
    
    // Helper to get client position from mouse or touch event
    const getClientX = (e) => {
      return e.touches ? e.touches[0].clientX : e.clientX;
    };
    
    const getClientY = (e) => {
      return e.touches ? e.touches[0].clientY : e.clientY;
    };
    
    // Handle start of drag (mouse or touch)
    const handleDragStart = (e) => {
      const clientX = getClientX(e);
      const clientY = getClientY(e);
      const offset = this.currentOffset;
      const mouseX = clientX - offset;
      const mouseY = clientY;
      
      // Check if clicking on a non-static body
      const bodiesUnderMouse = Matter.Query.point(
        window.shelfManager ? window.shelfManager.getAllBodies() : [],
        { x: mouseX, y: mouseY }
      );
      
      const hasInteractiveBody = bodiesUnderMouse.some(body => 
        !body.isStatic && body.collisionFilter.category !== 0x0001
      );
      
      // If not clicking on an interactive body, prepare for potential scene drag
      if (!hasInteractiveBody) {
        this.isDraggingScene = true;
        this.hasMovedDuringDrag = false;
        this.dragStartX = clientX;
        this.dragStartScroll = window.pageYOffset;
        this.lastMouseX = clientX;
        this.velocityTracker = [];
      }
    };
    
    // Listen for mousedown and touchstart on canvas
    canvas.addEventListener('mousedown', handleDragStart);
    canvas.addEventListener('touchstart', handleDragStart, { passive: true });
    
    // Handle drag movement (mouse or touch)
    const handleDragMove = (e) => {
      if (this.isDraggingScene) {
        const clientX = getClientX(e);
        const dragDelta = clientX - this.dragStartX;
        
        // Only start actually dragging if moved more than 3 pixels (prevents accidental drags during clicks)
        if (Math.abs(dragDelta) > 3) {
          this.hasMovedDuringDrag = true;
          
          const maxScroll = this.scrollSizer.offsetHeight - window.innerHeight;
          
          // Convert horizontal drag to scroll position
          const scrollDelta = (dragDelta / (this.maxBookX - this.width + 48)) * maxScroll;
          const targetScroll = Math.max(0, Math.min(maxScroll, this.dragStartScroll - scrollDelta));
          
          window.scrollTo(0, targetScroll);
          
          // Track velocity for inertia
          const now = Date.now();
          const deltaX = clientX - this.lastMouseX;
          this.velocityTracker.push({ deltaX, time: now });
          
          // Keep only recent samples (last 100ms)
          this.velocityTracker = this.velocityTracker.filter(v => now - v.time < 100);
          
          this.lastMouseX = clientX;
        }
      }
    };
    
    // Listen for mousemove and touchmove on document (so it works even if pointer leaves canvas)
    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('touchmove', handleDragMove, { passive: true });
    
    // Handle end of drag (mouse or touch)
    const handleDragEnd = () => {
      if (this.isDraggingScene) {
        // Only apply inertia if user actually dragged (not just clicked)
        if (this.hasMovedDuringDrag) {
          // Calculate velocity from tracker
          if (this.velocityTracker.length > 1) {
            const totalDelta = this.velocityTracker.reduce((sum, v) => sum + v.deltaX, 0);
            const totalTime = this.velocityTracker[this.velocityTracker.length - 1].time - this.velocityTracker[0].time;
            const velocity = totalTime > 0 ? (totalDelta / totalTime) * 1000 : 0; // pixels per second
            
            // Apply inertia to scroll
            if (Math.abs(velocity) > 50) {
              this.applyInertiaToScroll(velocity);
            }
            
            // Apply velocity to physics objects
            this.applyVelocityToObjects(velocity);
          }
        }
        
        this.isDraggingScene = false;
        this.hasMovedDuringDrag = false;
        this.velocityTracker = [];
      }
    };
    
    // Listen for mouseup and touchend on document
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchend', handleDragEnd, { passive: true });
  }
  
  applyInertiaToScroll(velocity) {
    const maxScroll = this.scrollSizer.offsetHeight - window.innerHeight;
    const currentScroll = window.pageYOffset;
    
    // Convert velocity to scroll distance
    const scrollVelocity = (velocity / (this.maxBookX - this.width + 48)) * maxScroll;
    const inertiaDistance = scrollVelocity * 0.5; // Damping factor
    const targetScroll = Math.max(0, Math.min(maxScroll, currentScroll - inertiaDistance));
    
    gsap.to(window, {
      scrollTo: targetScroll,
      duration: 0.8,
      ease: "power2.out"
    });
  }
  
  applyVelocityToObjects(velocity) {
    for (const bodyID in shelfManager.shelfObjects) {
      const body = shelfManager.shelfObjects[bodyID].body;
      physicsEngine.applyForceToBody(body, {
        x: velocity / 9000,
        y: 0
      });
    }
  }
  
  getTotalOffset() {
    return this.currentOffset;
  }
}

const scrollManager = new ScrollManager(canvas, booksContainer, maxBookX, width);
window.scrollManager = scrollManager; // Make it globally accessible

// Setup physics update loop
let boundaryCheckCounter = 0;
const boundaryCheckInterval = 30; // Check every 30 frames (~0.5 seconds at 60fps)

physicsEngine.onAfterUpdate(() => {
  // Update canvas position based on scroll
  const totalOffset = scrollManager.getTotalOffset();
  gsap.set(canvas, { x: totalOffset });
  
  // Update all object positions
  shelfManager.updateAllPositions();
  
  // Debounce boundary checks - only run every N frames
  boundaryCheckCounter++;
  if (boundaryCheckCounter >= boundaryCheckInterval) {
    boundaryCheckCounter = 0;
    
    // Check for objects that have escaped the boundaries
    const groundY = window.innerHeight;
    const escapeThreshold = 500; // Pixels beyond ground before resetting
    const leftEdge = 100; // Reset position from left edge
    const topEdge = 200; // Reset position from top
    
    Object.values(shelfManager.shelfObjects).forEach(obj => {
      const body = obj.body;
      
      // Skip static bodies
      if (body.isStatic) return;
      
      // Check if body has fallen too far below the ground or gone way off to the sides
      const isTooFarDown = body.position.y > groundY + escapeThreshold;
      const isTooFarLeft = body.position.x < -escapeThreshold;
      const isTooFarRight = body.position.x > maxX + escapeThreshold;
      const isTooFarUp = body.position.y < -escapeThreshold;
      
      if (isTooFarDown || isTooFarLeft || isTooFarRight || isTooFarUp) {
        // Reset position to top left of visible area
        Matter.Body.setPosition(body, { x: leftEdge, y: topEdge });
        // Reset velocity and rotation
        Matter.Body.setVelocity(body, { x: 0, y: 0 });
        Matter.Body.setAngularVelocity(body, 0);
        Matter.Body.setAngle(body, 0);
      }
    });
  }
});

// Setup mouse/touch event handlers
if (mouseConstraint) {
  Matter.Events.on(mouseConstraint, 'startdrag', function(event) {
    shelfManager.handleDragStart(event.body);
  });
  
  Matter.Events.on(mouseConstraint, 'enddrag', function(event) {
    shelfManager.handleDragEnd();
  });
}

let mouseX1, mouseY1, mouseX2, mouseY2;

// Helper to get client coordinates from mouse or touch event
function getEventCoords(e) {
  if (e.touches && e.touches.length > 0) {
    return { x: e.touches[0].clientX, y: e.touches[0].clientY };
  } else if (e.changedTouches && e.changedTouches.length > 0) {
    return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
  }
  return { x: e.clientX, y: e.clientY };
}

$("body").on("mousedown touchstart", function(e) {
  const coords = getEventCoords(e);
  mouseX1 = coords.x;
  mouseY1 = coords.y;
});

$('body').on('mousemove', debounce(function(e) {
  const coords = getEventCoords(e);
  mouseX2 = coords.x;
  mouseY2 = coords.y;
  shelfManager.handleMouseMove(mouseX2, mouseY2, scrollManager.getTotalOffset());
}));

$("body").on("mouseup touchend", function(e) {
  const coords = getEventCoords(e);
  mouseX2 = coords.x;
  mouseY2 = coords.y;
  
  const physicsCanvas = window.physicsEngine ? window.physicsEngine.render.canvas : null;
  
  // Only trigger click if:
  // 1. Clicking on the physics canvas
  // 2. Mouse hasn't moved since mousedown
  // 3. User didn't perform a scene drag
  if (physicsCanvas && e.target === physicsCanvas && (mouseX1 == mouseX2) && (mouseY1 == mouseY2) && !scrollManager.hasMovedDuringDrag) {
    shelfManager.handleClick(mouseX2, mouseY2, scrollManager.getTotalOffset());
  }
});

const drawerContainer = document.querySelector('[data-single-container]');
const contentContainer = document.querySelector('[data-drawer-inner]');
const contentContainerMain = contentContainer.querySelector('.site-main');
const bgOverlayContainer = document.querySelector('[data-single-overlay]');
const contentFooter = document.querySelector('[data-drawer-footer]');
const closeButton = document.querySelector('[data-close-drawer]');

const pageState = {
  drawerOpen: gauravVars.currentURL === gauravVars.homeURL ? false : true,
  activeCollection: gauravVars.activeCollection || false,
  collectionIndex: gauravVars.collectionIndex || 0,
  collectionNext: gauravVars.collectionNext || false,
  url: gauravVars.currentURL || window.location.href,
  hamburgerOpen: false
};

if ( pageState.drawerOpen ) {
  updateActiveCollection(gauravVars.activeCollection);

  if ( $('[data-ghost-article]').length && pageState.collectionNext !== false ) {
    $(contentFooter).hide();
  } else {
    $(contentFooter).show();
    $('[data-ghost-article]').hide();
  }
} else {
  $(contentFooter).hide();
}

const wait = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const gsapToAsync = (target, props) => {
  return new Promise((resolve) => {
    gsap.to(target, {
      ...props,
      onComplete: function() {
        if ( typeof props.onComplete === 'function' ) {
          props.onComplete();
        }
        resolve();
      }
    });
  });
}

function updateActiveCollection(newCollection) {
  pageState.activeCollection = newCollection;
  console.log('new active collection:' + newCollection);
  const footerBooks = $('.footer-books li');
  if ( newCollection !== false ) {
    footerBooks.each(function(){
      if ( $(this).find('.book').data('collection-id') == newCollection ) {
        console.log('hiding');
        $(this).hide();
      }
    });
  } else {
    footerBooks.show();
  }
}

function extractAndInjectInlineStyles(selector) {
  // Find all style tags within the newly added content
  const container = document.querySelector(selector);
  if (!container) return;
  
  const inlineStyles = container.querySelectorAll('style');
  const existingStylesInHead = new Set();
  
  // Track what's already in the head to avoid duplicates
  document.head.querySelectorAll('style').forEach(style => {
    existingStylesInHead.add(style.textContent.trim());
  });
  
  // Move inline styles to the head if not already there
  inlineStyles.forEach(style => {
    const content = style.textContent.trim();
    const styleId = style.id;
    
    // If style has an ID, check if it already exists and replace it
    if (styleId) {
      const existingStyle = document.getElementById(styleId);
      if (existingStyle && existingStyle.tagName === 'STYLE') {
        // Replace the content of existing style tag
        existingStyle.textContent = content;
        return;
      }
    }
    
    // Otherwise, add new style if content is unique
    if (content && !existingStylesInHead.has(content)) {
      const newStyle = document.createElement('style');
      if (styleId) newStyle.id = styleId;
      newStyle.textContent = content;
      document.head.appendChild(newStyle);
      existingStylesInHead.add(content);
    }
  });
}

function injectPageAssets(assets) {
  // Parse the assets HTML strings
  const parser = new DOMParser();
  
  // Track already loaded assets to avoid duplicates
  const loadedStyles = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(link => link.href);
  const loadedScripts = Array.from(document.querySelectorAll('script[src]')).map(script => script.src);
  const loadedInlineStyles = new Set();
  
  // Process styles
  if (assets.styles) {
    const stylesDoc = parser.parseFromString(assets.styles, 'text/html');
    
    // Inject link tags (external stylesheets)
    const linkTags = stylesDoc.querySelectorAll('link[rel="stylesheet"]');
    linkTags.forEach(link => {
      if (link.href && !loadedStyles.includes(link.href)) {
        const newLink = document.createElement('link');
        newLink.rel = 'stylesheet';
        newLink.href = link.href;
        if (link.media) newLink.media = link.media;
        if (link.id) newLink.id = link.id;
        document.head.appendChild(newLink);
      }
    });
    
    // Inject inline style tags
    const styleTags = stylesDoc.querySelectorAll('style');
    styleTags.forEach(style => {
      const styleContent = style.textContent.trim();
      const styleId = style.id;
      
      // If style has an ID, check if it already exists and replace it
      if (styleId) {
        const existingStyle = document.getElementById(styleId);
        if (existingStyle && existingStyle.tagName === 'STYLE') {
          // Replace the content of existing style tag
          existingStyle.textContent = styleContent;
          return;
        }
      }
      
      // Otherwise, add new style if content is unique
      if (styleContent && !loadedInlineStyles.has(styleContent)) {
        const newStyle = document.createElement('style');
        if (styleId) newStyle.id = styleId;
        if (style.media) newStyle.media = style.media;
        newStyle.textContent = styleContent;
        document.head.appendChild(newStyle);
        loadedInlineStyles.add(styleContent);
      }
    });
  }
  
  // Process scripts
  if (assets.scripts) {
    const scriptsDoc = parser.parseFromString(assets.scripts, 'text/html');
    
    // Inject script tags
    const scriptTags = scriptsDoc.querySelectorAll('script');
    scriptTags.forEach(script => {
      // External scripts
      if (script.src && !loadedScripts.includes(script.src)) {
        const newScript = document.createElement('script');
        newScript.src = script.src;
        if (script.id) newScript.id = script.id;
        if (script.async) newScript.async = true;
        if (script.defer) newScript.defer = true;
        document.head.appendChild(newScript);
      }
      // Inline scripts (be careful with these - they may need the DOM to be ready)
      else if (!script.src && script.textContent.trim()) {
        const newScript = document.createElement('script');
        if (script.id) newScript.id = script.id;
        newScript.textContent = script.textContent;
        document.body.appendChild(newScript);
      }
    });
  }
}

async function appendContent(url, callback = false) {
  ajaxIsLoading = true;

  const renderPost = async function(post) {
    if ( document.querySelector('[data-ghost-article]') ) {
      if ( ghostMarkup === null ) {
        ghostMarkup = document.querySelector('[data-ghost-article]').outerHTML;
      }
      
      await gsapToAsync('[data-ghost-article]', {
        opacity: 0,
        duration: 0.3,
        onComplete: function() {
          $('[data-ghost-article]').remove();
        }
      });
    }

    // Inject page-specific assets if available
    if (post.page_assets) {
      injectPageAssets(post.page_assets);
    }

    const article = document.createElement('article');
    article.innerHTML = post.header_template + '<div class="page-content content-margins content-container centered-margins">' + post.content.rendered + '</div>';
    contentContainerMain.insertAdjacentHTML( 'beforeend', post.article_template );
    
    // Extract and inject any inline styles from the newly added content
    extractAndInjectInlineStyles('.site-article:not(.initialized)');

    initContentScripts('.site-article:not(.initialized)');

    // update the title
    document.title = post.title.rendered;

    // update the URL
    pageState.url = post.link;

    updateActiveCollection(post.collection);
    if ( post.collection_next !== null ) {
      $(contentFooter).hide();
      pageState.collectionNext = post.collection_next;
      
      console.log('there is a next post in this collection:', post.collection_next);
      console.log(ajaxIsLoading);
      setupInfiniteScroll();
    } else {
      $(contentFooter).show();
      $('[data-ghost-article]').hide();
      console.log($('[data-ghost-article]'));
      pageState.collectionNext = null;
      if ( infiniteScrollTrigger !== null ) {
        infiniteScrollTrigger.disable();
      }
    }
  }

  if ( cachedPosts.hasOwnProperty(url) && cachedPosts[url] !== null ) {
    console.log('rendering from browser cache:', cachedPosts[url]);
    ajaxIsLoading = false;
    renderPost(cachedPosts[url]).then(function() {
      ajaxIsLoading = false;
      if ( typeof callback === 'function' ) {
        callback();
      }
    });

    return;
  }

  cachedPosts[url] = null;

  ajaxRequest = $.ajax({
    url: gauravVars.restURL + 'wp/v2/posts',
    type: 'GET',
    data: {
      per_page: 1,
      _embed: true,
      url: pageState.url,
      _fields: 'id,title,link,content,header_template,article_template,collection,collection_next,page_assets'
    },
    success: async function(data) {
      ajaxIsLoading = false;
      if ( data.length > 0 ) {
        console.log('appending this data:');
        console.log(data);
        const post = data[0];
        
        // Debug: Check if page_assets exists
        if (post.page_assets) {
          console.log('page_assets found:', post.page_assets);
        } else {
          console.warn('page_assets field is missing from REST API response');
        }
        
        cachedPosts[url] = post;

        renderPost(post).then(function() {
          if ( typeof callback === 'function' ) {
            callback();
          }
        })
      } else {
        console.warn('No more posts in this collection.');
        if ( infiniteScrollTrigger !== null ) {
          infiniteScrollTrigger.disable();
        }
      }
    },
  })
}

let infiniteScrollTrigger = null;



const headerArea = document.querySelector('[data-header-area]');
const hamburgerContainer = document.querySelector('[data-hamburger-menu]');
const hamburgerButton = document.querySelector('[data-hamburger-toggle]');

const openHamburger = (callback = false) => {
  const openTL = gsap.timeline({
    onComplete: function() {
      pageState.hamburgerOpen = true;
      if ( typeof callback === 'function' ) {
        callback();
      }
    },
    onStart: function() {
      hamburgerButton.classList.add('active');
      headerArea.style.zIndex = 100;
    }
  });

  openTL.to(hamburgerContainer, {
    x: '-=100%',
    duration: 0.56,
    ease: 'power3.inOut',
    onStart: function() {
      hamburgerContainer.style.pointerEvents = 'auto';
      hamburgerContainer.style.visibility = 'visible';
      hamburgerContainer.setAttribute('aria-hidden', false);
    }
  });

  openTL.to(bgOverlayContainer, {
    opacity: 0.45,
    duration: 0.4,
    ease: 'power3.inOut',
    onStart: function() {
      bgOverlayContainer.style.pointerEvents = 'auto';
      bgOverlayContainer.style.visibility = 'visible';
    }
  }, '0');
}

const closeHamburger = (callback = false, fadeOverlay = true) => {
  const closeTL = gsap.timeline({
    onComplete: function() {
      pageState.hamburgerOpen = false;
      hamburgerButton.classList.remove('active');
      headerArea.style.zIndex = '';
      if ( typeof callback === 'function' ) {
        callback();
      }
    }
  });

  closeTL.to(hamburgerContainer, {
    x: '+=100%',
    duration: 0.56,
    ease: 'power3.inOut',
    onComplete: function() {
      hamburgerContainer.setAttribute('aria-hidden', true);
      hamburgerContainer.style.pointerEvents = 'none';
      hamburgerContainer.style.visibility = 'hidden';
    }
  });

  if ( fadeOverlay ) {
    closeTL.to(bgOverlayContainer, {
      opacity: 0,
      duration: 0.4,
      ease: 'power3.inOut',
      onComplete: function() {
        bgOverlayContainer.style.pointerEvents = 'none';
        bgOverlayContainer.style.visibility = 'hidden';
      }
    }, '0');
  }
}

const openContent = (callback = false) => {
  const openTL = gsap.timeline({
    onComplete: function() {
      if ( infiniteScrollTrigger !== null ) {
        infiniteScrollTrigger.enable();
      }
      pageState.drawerOpen = true;
      if ( typeof callback === 'function' ) {
        callback();
      }
    },
    onStart: function() {
      if ( ghostMarkup !== null && document.querySelector('[data-ghost-article]') === null ) {
        contentContainerMain.insertAdjacentHTML( 'beforeend', ghostMarkup );
      }
    }
  });

  openTL.set(drawerContainer, {
    x: isMobile ? '0' : '100%',
    y: isMobile ? '100%' : '0',
  });

  openTL.to(drawerContainer, {
    x: '0',
    y: '0',
    duration: 0.56,
    ease: 'power3.inOut',
    onStart: function() {
      drawerContainer.style.pointerEvents = 'auto';
      drawerContainer.style.visibility = 'visible';
      drawerContainer.setAttribute('aria-hidden', false);
    }
  });

  openTL.to(bgOverlayContainer, {
    opacity: 0.45,
    duration: 0.4,
    ease: 'power3.inOut',
    onStart: function() {
      bgOverlayContainer.style.pointerEvents = 'auto';
      bgOverlayContainer.style.visibility = 'visible';
    }
  }, '0');
};

const closeContent = (callback = false) => {
  const closeTL = gsap.timeline({
    onComplete: function() {
      if ( infiniteScrollTrigger !== null ) {
        infiniteScrollTrigger.disable();
      }
      pageState.drawerOpen = false;
      const articles = contentContainerMain.querySelectorAll('article');
      articles.forEach(function(article) {
        article.remove();
      });
      updateActiveCollection(false);
      if ( typeof callback === 'function' ) {
        callback();
      }
    },
    onStart: function() {
      if ( ajaxRequest !== null ) {
        ajaxRequest.abort();
        ajaxRequest = null;
        ajaxIsLoading = false;
      }
    }
  });

  closeTL.to(drawerContainer, {
    x: isMobile ? '0' : '100%',
    y: isMobile ? '100%' : '0',
    duration: 0.56,
    ease: 'power3.inOut',
    onComplete: function() {
      drawerContainer.setAttribute('aria-hidden', true);
      drawerContainer.style.pointerEvents = 'none';
      drawerContainer.style.visibility = 'hidden';
    }
  });

  closeTL.to(bgOverlayContainer, {
    opacity: 0,
    duration: 0.4,
    ease: 'power3.inOut',
    onComplete: function() {
      bgOverlayContainer.style.pointerEvents = 'none';
      bgOverlayContainer.style.visibility = 'hidden';
      $(contentFooter).hide();
    }
  }, '0');
};

const updatePageState = (source = false) => {
  let isInfiniteScroll = false;

  if ( pageState.hamburgerOpen ) {
    closeHamburger(function(){
      openContent(function(){
        appendContent(pageState.url, function() {
          ScrollTrigger.refresh();
        });
      });
    }, false);
    return;
  }

  if ( source === 'infinite scroll' ) {
    isInfiniteScroll = true;
    pageState.url = pageState.collectionNext;
  }

  if ( source !== 'popstate' && source !== 'infinite scroll' ) {
    history.pushState(pageState, '', pageState.url);
  } 

  if ( pageState.url === gauravVars.homeURL ) { // go back to homepage
    closeContent();
  } else {
    if ( pageState.drawerOpen ) { // infinite scroll
      if ( isInfiniteScroll ) {
        console.log('was infinite scroll');
        appendContent(pageState.collectionNext, function() {
          ScrollTrigger.refresh();
        });
      } else {
        console.log('was not infinite scroll');
        let origUrl = pageState.url;
        closeContent(function() {
          pageState.url = origUrl;
          pageState.collectionNext = false;
          updatePageState();
        });
      }
    } else {
      openContent(function(){
        appendContent(pageState.url, function() {
          ScrollTrigger.refresh();
        });
      });
    }
  }
}

const setupInfiniteScroll = () => {
  if ( infiniteScrollTrigger !== null ) {
    infiniteScrollTrigger.kill();
  }

  infiniteScrollTrigger = ScrollTrigger.create({
    scroller: drawerContainer,
    trigger: $('[data-ghost-article]'),
    start: 'top bottom',
    end: 'bottom top',
    onEnter: function() {
      if ( ajaxIsLoading === true ) {
        return;
      }

      console.log('infinite scroll has triggered:');
      console.log(pageState.collectionNext);
      if ( pageState.collectionNext !== false ) {
        console.log('updating page state for infinite scroll');
        updatePageState('infinite scroll');
      }
    }
  });
}

$(closeButton).on('click', function(e){
  pageState.url = gauravVars.homeURL;
  pageState.collectionNext = false;
  updatePageState();
});

$(bgOverlayContainer).on('click', function(e){
  if ( pageState.drawerOpen ) {
    pageState.url = gauravVars.homeURL;
    pageState.collectionNext = false;
    updatePageState();
  } else if ( pageState.hamburgerOpen ) {
    closeHamburger();
  }
});

const preloadInternalLink = (url) => {
  if ( cachedPosts.hasOwnProperty(url) ) return; // dont make a request if we already have it or in progress

  cachedPosts[url] = null; // mark as in-progress
  $.ajax({
    url: gauravVars.restURL + 'wp/v2/posts',
    type: 'GET',
    data: {
      per_page: 1,
      _embed: true,
      url: url
    },
    success: async function(data) {
      ajaxIsLoading = false;
      if ( data.length > 0 ) {
        const post = data[0];
        cachedPosts[url] = post;
        console.log('preloaded this data:');
        console.log(post);
      }
    }
  });
};

if ( $(hamburgerContainer).find('.hamburger-book a') ) {
  $(hamburgerContainer).find('.hamburger-book a').each(function(){
    if ( this.href.indexOf(gauravVars.homeURL) === -1 ) return;
    preloadInternalLink(this.href);
  });
}

$('body').on('mouseenter', 'a', function(e) {
  const href = new URL($(this).attr('href'), window.location.origin);
  if ( $(e.target).closest('#wpadminbar').length ) return; // don't interfere with admin bar links
  if ( href.origin === gauravVars.homeURL ) {
    if ( !this.classList.contains('copybutton') && !cachedPosts.hasOwnProperty(href.href) ) { // attempt to preload internal links
      preloadInternalLink(href.href);
    }
  }
});

$('body').on('click', 'a', function(e) {
  const href = new URL($(this).attr('href'), window.location.origin);
  if ( $(e.target).closest('#wpadminbar').length ) return; // don't interfere with admin bar links
  if ( href.origin === gauravVars.homeURL ) {
    e.preventDefault();
    if ( this.classList.contains('copybutton') ) { // share button
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(this).focus();
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    } else { // internal link
      console.log('disabling infinite scroll');
      if ( infiniteScrollTrigger !== null ) {
        infiniteScrollTrigger.disable();
      }
      pageState.url = href.href;
      updatePageState('click');
    }
  }
});

$(hamburgerButton).on('click', function(e){
  if ( $(this).hasClass('active') ) {
    closeHamburger();
  } else {
    openHamburger();
  }
});

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

function initContentScripts(scope) {
  if ( $(scope).find('.modal-area').length ) {
    $(scope).find('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $(scope).find('.smooth-scroller').length ) { // internal links, smooth scrolling
    $(scope).find('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  if ( $(scope).find('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').length ) {
    $(scope).find('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? [] : controls ) : ($(el).is('video') ? [] : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false )
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $(scope).find('.wp-block-audio').length ) {
    $(scope).find('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $(scope).find('.wp-block-gallery').length ) {
    $(scope).find('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }
  
  // dropdowns
  if ( $(scope).find('.gaurav-dropdown').length ) {
    $(scope).find('.gaurav-dropdown').each(function(){
      const toggle = $(this).find('.gaurav-dropdown__toggle');
      const wrapper = $(this).find('.gaurav-dropdown__inner');
      const dropdown = $(this).find('.gaurav-dropdown__dropdown');
      let isAnimating = false;
      
      $(dropdown).css({
        width: 'auto'
      });
      
      $(wrapper).css({
        'width': Math.round(dropdown.width() + 16) + 'px'
      });
      
      $(dropdown).css({
        width: '100%'
      });
      
      const openDropdown = (e) => {
        $(toggle).attr('aria-expanded', 'true');
        
        $(dropdown).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          ease: 'power2.inOut',
          overwrite: true
        });
      };
      
      const closeDropdown = (e) => {
        $(toggle).attr('aria-expanded', 'false');
        
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          ease: 'power2.inOut',
          overwrite: true,
          onComplete: function(){
            $(dropdown).css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      };
      
      toggle.on('click', function(e){        
        if ( $(this).attr('aria-expanded') == 'true' ) {
          closeDropdown(e);
        } else {
          openDropdown(e);
        }
      });
      
      if ( window.matchMedia('pointer: fine') ) {
        $(this).on('mouseenter', function(e){
          openDropdown(e);
        });
        
        $(this).on('mouseleave', function(e){
          closeDropdown(e);
        });
      }
      
      if ( $(this).find('.gaurav-dropdown__input-input') ) {
        $(this).find('.gaurav-dropdown__input-input').on('change', function(){
          if ( $(this).is(':checked') ) {
            $(toggle).text( $(this).siblings('.gaurav-dropdown__input__label').text() );
          }
        });
      }
    });
  }

  //accordion
  if ( $(scope).find('.accordion-inner').length ) {
    $(scope).find('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  
  if ( $(scope).find('.logo-ticker').length ) {
    $(scope).find('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      
      while ( curW && curW !== 0 && curW < oldSize * 2 ) {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      }
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
      });
    });
  }

  // content animations
  const animatedText = $(scope).find('.acf-innerblocks-container, .content-container, .post-header__inner').not('.dont-animate').children('h1, h2, h3, h4, h5, h6, p.has-intro-font-size, .has-h-1-font-size, .has-h-2-font-size, .has-h-3-font-size, .has-h-4-font-size, .has-h-5-font-size, .has-h-6-font-size');
  animatedText.each(function(){
    let split = false;
    let completed = false;
    $(this).find('strong, bold, em, i').css({
      'display': 'inline-block',
    })

    $(this).addClass('animated');

    const setupSplit = (() => {
      if ( completed ) {
        return;
      }

      if ( this.classList.contains('animating') ) {
        return;
      }

      if ( split !== false ) {
        if ( this.querySelector('.line-wrapper').classList.contains('completed') ) {
          split.revert();
          completed = true;
          split = false;
          return;
        }

        split.revert();
      }

      split = new SplitText(this, {
        type: 'lines',
        linesClass: "heading-line line++"
      });

      $(this).find('.heading-line').wrap('<div class="line-wrapper"></div>');
    
      gsap.set(split.lines, {
        y: 56,
        opacity: 0
      });

      ScrollTrigger.refresh();
    }).bind(this)

    fontsLoadedActions.push(() => {
      setupSplit();
    });
    
    
    $(window).on('resize', function(){
      setupSplit();
    });

    setupSplit();
  });

  const simplerAnimatedElements = $(scope).find('.acf-innerblocks-container, .content-container, .post-header__inner, .post-header__image').not('.dont-animate').children().not('.animated');
  gsap.set(simplerAnimatedElements, {
    y: 56,
    opacity: 0
  });

  const batch = ScrollTrigger.batch([...animatedText, ...simplerAnimatedElements], {
    scroller: drawerContainer,
    start: 'top bottom-=80',
    end: 'bottom top',
    onEnter: (batch) => {
      batch.forEach((el, index) => {
        if ( el.classList.contains('animated') ) {
          gsap.to(el.querySelectorAll('.heading-line'), {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power3.inOut',
            delay: index * 0.08,
            stagger: {
              each: 0.08
            },
            onStart: function() {
              el.classList.add('animating');
            },
            onComplete: function() {
              el.querySelectorAll('.line-wrapper').forEach((line) => {
                line.classList.add('completed');
              });
            }
          })
        } else {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: 0.7,
            ease: 'power3.inOut',
            delay: index * 0.08
          })
        }
      })
    }
  });

  $(scope).addClass('initialized');
}

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip, SplitText, InertiaPlugin);

  if ( pageState.url !== gauravVars.homeURL ) {
    setupInfiniteScroll();
  }

  if ( $('.site-article').length ) {
    $('.site-article').each(function() {
      initContentScripts(this);
    });
  }

  if ( $('[data-drawer-footer]').length ) {
    $('[data-drawer-footer]').each(function() {
      const books = $(this).find('.book-display-horizontal');
      if ( books.length ) {
        const setupBooks = () => {
          books.each(function(index) {
            const bookComponent = this.querySelector('.book-horizontal');
            bookComponent.style.marginRight = rand(seed + '*' + index)(56) + 'px';

          });
        };

        windowResizeActions.push(setupBooks);
        setupBooks();
      }
    });
  }

  if ( $('[data-refresh-button]').length ) {
    $('[data-refresh-button]').on('click', function(){
      // Reset all objects to their initial positions with new randomization
      if (window.shelfManager && window.layoutManager) {
        window.shelfManager.resetAllObjects(window.layoutManager);
      }
    });
  }

  let documentWasHidden = false;
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      window.shelfManager.resetAllObjects(window.layoutManager);
      documentWasHidden = true;
    } else if (documentWasHidden) {
      documentWasHidden = false;
    }
  });

  if ( $('[data-nightmode-toggle]').length ) {
    $('[data-nightmode-toggle]').on('change', function(e){
      if ( $(this).is(':checked') ) {
        $('body').addClass('tw-dark');
        window.localStorage.setItem('tw-dark', 'true');
      } else {
        $('body').removeClass('tw-dark');
        window.localStorage.setItem('tw-dark', 'false');
      }
    });
  }

  if ( $('[data-playlist-area]').length ) {
    const playlist = $('[data-playlist-area]');
    const toggle = $('[data-playlist-toggle]');
    const modal = $('[data-playlist-modal]');

    $('body').on('click', function(e){
      if ( modal.hasClass('active') && ((!$(e.target).closest(modal).length && !$(e.target).closest(toggle).length && !$(e.target).is(modal) && !$(e.target).is(toggle) && !$(e.target).closest('[data-object="speaker"]').length) && !ignoreThisOneClick) ) {
        ignoreThisOneClick = false;
        modal.removeClass('active');
        toggle.get(0).removeAttribute('open');
        gsap.to(modal, {
          y: '100%',
          duration: 0.8,
          ease: 'power3.inOut',
          onComplete: function() {
            gsap.set(modal, {
              visibility: 'hidden',
              pointerEvents: 'none'
            });
          }
        });
        $('body').removeClass('no-scroll');
      }
    });

    toggle.on('click', function(e){
      e.preventDefault();
      
      if ( modal.hasClass('active') ) {
        modal.removeClass('active');
        toggle.get(0).removeAttribute('open');
        gsap.to(modal, {
          y: '100%',
          duration: 0.8,
          ease: 'power3.inOut',
          onStart: function() {
            // alert('reversing');
          },
          onComplete: function() {
            gsap.set(modal, {
              visibility: 'hidden',
              pointerEvents: 'none'
            });
          }
        });
        $('body').removeClass('no-scroll');
      } else {
        modal.addClass('active');
        toggle.attr('open', 'true');
        // console.log(modal,toggle);
        gsap.set(modal, {
          y: '100%'
        });
        gsap.to(modal, {
          y: 0,
          duration: 0.8,
          ease: 'power3.inOut',
          onStart: function() {
            // alert('starting');
            gsap.set(modal, {
              visibility: 'visible',
              pointerEvents: 'auto'
            })
          }
        });
        $('body').addClass('no-scroll');
      }
    }).on('keypress', handleKeypressADA);
  }
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('figure').length;

  const captions = [];

  $(el).find('figure').each(function(){
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('figcaption').clone(true) );
      $(this).find('figcaption').remove();
    } else {
      captions.push('<div style="height:10px;"></div>');
    }
  });

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('slick-gallery').addClass('alignwide').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> / <b>' + count +'</b></div><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');


  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = nav.find('.slick-gallery-nav__captions');
  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }

  captionsContainer.slick({
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    fade: true
  });

  $(el).slick({
    adaptiveHeight: true,
    // prevArrow: prevArrow,
    // nextArrow: nextArrow,
    appendArrows: nav,
    asNavFor: captionsContainer,
  });

  $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
  });
}

// Custom Search Close Button
$(document).ready(function() {
  $('.search-close').on('click', function() {
    $('.site-searchform__input').val('');
  });
});


const computeCOM = (path) => {
  const hull = path.pathseglist._list.map(seg => {
    return []
  });
  // https://en.wikipedia.org/wiki/Centroid#Of_a_polygon
  let area = 0
  for (let i = 0; i < hull.length; i++) {
    const j = (i + 1) % hull.length
    area += hull[i].x * hull[j].y - hull[j].x * hull[i].y
  }
  area /= 2

  let x = 0
  let y = 0
  for (let i = 0; i < hull.length; i++) {
    const j = (i + 1) % hull.length
    x +=
      (hull[i].x + hull[j].x) * (hull[i].x * hull[j].y - hull[j].x * hull[i].y)
    y +=
      (hull[i].y + hull[j].y) * (hull[i].x * hull[j].y - hull[j].x * hull[i].y)
  }
  x /= 6 * area
  y /= 6 * area

  return new [x,y];
}

function shuffle(origArr) {
  const array = [...origArr];

  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}
